module.exports = __webpack_public_path__ + "media/images/client/favicons/apple-touch-icon-72x72-precomposed-ba3d139a5fcb6f8e6950a7b93f03af4d.png";